// extracted by mini-css-extract-plugin
export default {"subHeadingRow":"ExamGridWrapper__subHeadingRow___XPWBZ","classId":"ExamGridWrapper__classId___tufka"};